import t from"./_overArg.js";var e=t(Object.getPrototypeOf,Object);export{e as default};
//# sourceMappingURL=_getPrototype.js.map
